var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMenu = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.305,
    height: 24.099,
    viewBox: "0 0 31.305 24.099",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.548 -75.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3118",
    "data-name": "Grupo 3118",
    transform: "translate(-0.031 86.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3117",
    "data-name": "Grupo 3117",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M29.019,236H1.179a1.159,1.159,0,0,0-1.047.63,1.379,1.379,0,0,0,0,1.3,1.159,1.159,0,0,0,1.047.63H29.024a1.289,1.289,0,0,0,0-2.561Z",
    transform: "translate(0.031 -235.999)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3120",
    "data-name": "Grupo 3120",
    transform: "translate(0.041 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3119",
    "data-name": "Grupo 3119",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M29.009,76H1.175a1.289,1.289,0,0,0,0,2.561H29.014a1.289,1.289,0,0,0,0-2.561Z",
    transform: "translate(-0.031 -76)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3122",
    "data-name": "Grupo 3122",
    transform: "translate(-0.03 96.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3121",
    "data-name": "Grupo 3121",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M29.025,396H1.18a1.159,1.159,0,0,0-1.047.63,1.379,1.379,0,0,0,0,1.3,1.159,1.159,0,0,0,1.047.63h27.85a1.159,1.159,0,0,0,1.047-.63,1.379,1.379,0,0,0,0-1.3,1.159,1.159,0,0,0-1.047-.63Z",
    transform: "translate(0.03 -396)",
    strokeWidth: 1
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu.1bfc76cc.svg";
export { ForwardRef as ReactComponent };